import baseRequest from "../_core/baseRequest";

export default {
    //#region permissionPolicy endpoints
    listPermissionPolicies: ({searchText, skip, limit}) =>
        baseRequest.get(
            `authorization/permission-policies?${searchText ? "&searchText=" + searchText : ""}${
                skip ? "&skip=" + skip : ""
            }${limit ? "&limit=" + limit : ""}`
        ),
    createPermissionPolicy: params => baseRequest.post("authorization/permission-policies", params),
    updatePermissionPolicy: ({permissionPolicyId, ...params}) =>
        baseRequest.put(`authorization/permission-policies/${permissionPolicyId}`, params),
    deletePermissionPolicy: ({permissionPolicyId}) =>
        baseRequest.post(`authorization/permission-policies/${permissionPolicyId}/delete`, {}),
    //#endregion

    //#region userGroup endpoints
    listUserGroups: ({searchText, skip, limit}) =>
        baseRequest.get(
            `authorization/user-groups?${searchText ? "&searchText=" + searchText : ""}${
                skip ? "&skip=" + skip : ""
            }${limit ? "&limit=" + limit : ""}`
        ),
    createUserGroup: params => baseRequest.post("authorization/user-groups", params),
    updateUserGroup: ({userGroupId, ...params}) =>
        baseRequest.put(`authorization/user-groups/${userGroupId}`, params),
    deleteUserGroup: ({userGroupId}) =>
        baseRequest.post(`authorization/user-groups/${userGroupId}/delete`, {})
    //#endregion
};
